import React from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { withRouter } from 'react-router'
import { stores, view } from '../../../stores'
import { Loader } from '../../../components/ui/states/Loader'
import { InquiryTypes } from '../../../constants/InquiryTypes'
import { InquiryFrequencies } from '../../../constants/InquiryFrequencies'
import { InquiryDetails } from '../../../components/inquiries/InquiryDetails'
import { InquiryPage } from '../InquiryPage'
import { ProposalAccepted } from './ProposalAccepted'
import { MaintenanceProposalsWaiting } from './MaintenanceProposalsWaiting'

import { InquiryStatus } from '../../../constants/InquiryStatus'
import { ProposalStatus } from '../../../constants/ProposalStatus'

import './InquiryMaintenancePage.css'
import { PagesPaths } from '../../../constants/Pages'

class InquiryMaintenancePageComponent extends InquiryPage {
  async componentDidMount () {
    await this.getInquiry()
    await stores.account.getPaymentMandate()
    await stores.account.getWallet()
  }

  get type () { return InquiryTypes.REALISATION }
  get frequency () { return InquiryFrequencies.MAINTENANCE }

  async selected ({ id, asAdmin, paymentType }) {
    stores.inquiries.select({ proposal: id })
    await stores.inquiries.accept({ asAdmin, paymentType })
    await stores.account.getInterventionDate()
  }

  async onCloseSearch () {
    const { history } = this.props
    await stores.inquiries.close()
    // warning - technical debt -
    // API returns WAITING in most cases (but CANCELLED after some time)
    // We expect the inquiry to be cancelled if no proposals to get around this issue
    if (!stores.inquiries.inquiry.proposals.length) {
      history.push(PagesPaths.INQUIRIES.path)
    }
  }

  get content () {
    const { token } = stores.authentication
    const { inquiry, selected } = stores.inquiries
    switch (inquiry.status) {
    case InquiryStatus.WAITING:
      return (
        <MaintenanceProposalsWaiting
          type={this.type}
          inquiry={inquiry}
          frequency={this.frequency}
          asAdmin={token.asAdmin}
          hidden={!!selected}
          onSelect={this.selected} />)
    case InquiryStatus.ACCEPTED:
    case InquiryStatus.FINISHED:
      const proposal = inquiry.proposals.find((p) => [ProposalStatus.ACCEPTED, ProposalStatus.FINISHED].includes(p.status))
      return (
        <ProposalAccepted
          proposal={proposal}
          frequency={this.frequency} />)
    default:
      return (<span />)
    }
  }

  render () {
    const { inquiry } = stores.inquiries

    if (!this.ready) {
      return (<Loader />)
    }

    return (
      <InquiryDetails inquiry={inquiry} account={stores.account.connected} onCloseSearch={() => this.onCloseSearch()}>
        { this.content }
      </InquiryDetails>
    )
  }
}

InquiryMaintenancePageComponent.propTypes = {
  t: func,
  match: object
}

export const InquiryMaintenancePage = withRouter(translate()(view(InquiryMaintenancePageComponent)))



// WEBPACK FOOTER //
// ./src/pages/demandes/maintenances/InquiryMaintenancePage.js